import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { AllLevelRestrictionDispatcher, RestrictionDispatcher } from "./Variable";
import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { RestrictionTypeEnum } from "../../../../../../Wrap/Constants/Enums/RestrictionTypeEnum";
import { ActiveAccountRestriction } from "../../../../../../Wrap/Models/Models/Account/Restrictions/ActiveAccountRestriction";
import { RestrictionReasonTypeEnum } from "../../../../../../Wrap/Constants/Enums/RestrictionReasonTypeEnum";

export interface RestrictionStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: Array<ActiveAccountRestriction>;
}

export class AllLevelRestrictionStoreStatic extends BaseStore<RestrictionStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(AllLevelRestrictionDispatcher, (actionData) => this.onRestrictionStoreResponse(actionData));
    }

    protected getDefaultState(): RestrictionStoreStaticState {
        return {
            actionType: ActionType.Loading,
            data: null,
            isLoading: false,
        };
    }

    public getLastResult(): RestrictionStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data ??[];
    }

    private onRestrictionStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload, isLoading: false });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error, isLoading: false });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}

export class RestrictionStoreStatic extends BaseStore<RestrictionStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(RestrictionDispatcher, (actionData) => this.onRestrictionStoreResponse(actionData));
    }

    public getLastResult(): RestrictionStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }
    public transferDisabled() {
        const data = this.getState().data?.find((a) => a?.Restriction == RestrictionTypeEnum.TransferIn) ? true : false;
        return data;
    }
    public buyDisabled() {
        const data = this.getState().data?.find((a) => a?.Restriction == RestrictionTypeEnum.BuyOrder) ? true : false;
        return data;
    }

    public sellDisabled() {
        const data = this.getState().data?.find((a) => a?.Restriction == RestrictionTypeEnum.SellOrder) ? true : false;
        return data;
    }

    public depositDisabled() {
        const data = this.getState().data?.find((a) => a?.Restriction == RestrictionTypeEnum.Deposit) ? true : false;
        return data;
    }

    public WithdrawDisabled() {
        const data = this.getState().data?.find((a) => a?.Restriction == RestrictionTypeEnum.Withdraw) ? true : false;
        return data;
    }

    public InterAccountTransferDisabled() {
        const data = this.getState().data?.find((a) => a?.Restriction == RestrictionTypeEnum.InterAccountTransfer)
            ? true
            : false;
        return data;
    }

    public CustomerRestrictionApplied() {
        const data = this.getState().data?.find(
            (a) =>
                a?.RestrictionReason == RestrictionReasonTypeEnum.DeathIndividual ||
                a?.RestrictionReason == RestrictionReasonTypeEnum.DeathJoint ||
                a?.RestrictionReason == RestrictionReasonTypeEnum.NoAmlPass ||
                a?.RestrictionReason == RestrictionReasonTypeEnum.Pep ||
                a?.RestrictionReason == RestrictionReasonTypeEnum.FinancialSanction ||
                a?.RestrictionReason == RestrictionReasonTypeEnum.HighRiskCustomer
        )
            ? true
            : false;
        return data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): RestrictionStoreStaticState {
        return {
            actionType: ActionType.Loading,
            data: null,
            isLoading: false,
        };
    }

    private onRestrictionStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload, isLoading: false });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error, isLoading: false });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}
